const PERMISSION_CREATE = 'hasCreate' || 'create'
const PERMISSION_EDIT = 'hasEdit' || 'edit'
const PERMISSION_SHOW = 'hasShow'
const PERMISSION_LIST = 'hasList'
const PERMISSION_DELETE = 'hasDelete' || 'delete'
const PERMISSION_GET = 'get'
const VIEW_LIQUIDATION_WHOLESALER = 'view_liquidation_wholesaler'
const VIEW_LIQUIDATION_RETAIL = 'view_liquidation_retail'
const VIEW_LIQUIDATION_SUPPLIER = 'view_liquidation_supplier'
const PERMISSION_ISSUANCE = 'issuance'
const PERMISSION_CHANGE = 'change'
const PERMISSION_REFOUND = 'refund'
const PERMISSION_CANCEL = 'cancel'
const PERMISSION_GUARANTEE = 'guarantee'
const PERMISSION_GENERATE = 'generate' // Si el usuario no tiene ese permiso, no tiene que poder ver ni usar el botón de Crear Reserva y Editar que estan en la vista dentro de cada reserva, y en la vista del listado de Reservas (y en ningún otro lado si es que hay otro).
const PERMISSION_VIEW = 'view' // para ver tags por ejemplo
const PERMISSION_ASSIGN = 'assign' // para asignar  tags por ejemplo
const PERMISSION_MOVE = 'move'
const PERMISSION_DELETED = 'delete' // por fuera al de react admin
const PERMISSION_EDITED = 'edit' // por fuera al de react admin
const PERMISSION_LIST_SHOW = 'list' // por fuera al de react admin
const PERMISION_VIEW_CANCEL_SUPPLIER = 'view_cancel_supplier'
const PERMISSION_AMEND = 'amend' // permiso para boton de editar de reserva offile
const PERMISSION_EXPORT = 'export'
const PERMISSION_IMPORT = 'import'
const PERMISSION_IS_BILLABLE = 'is-billable'
const PERMISSION_AUTO_BILL = 'auto-bill'
const PERMISSION_FORCED_CANCELLATION = 'cancel_force'
const PERMISSION_RECEIPT = 'receipt'
const PERMISSION_RETRIVE = 'retrieve' // permiso para mostrar el boton actualizar en en trenes
const PERMISSION_CAPTURE = 'capture'
const PERMISSION_PAYMENT = 'payment' // permiso para mostrar el boton de pagar item de aereos
const PERMISSION_VOID = 'void' // permiso para mostrar el boton de void item de aereos
const PERMISSION_EDIT_DUE_DATE = 'edit_due_date' // permiso para editar fecha final
const PERMISSION_PRICING = 'pricing' // permiso para editar pricing del pasajero
const PERMISSION_FRAUD = 'fraud' // permiso para aprobar o rechazar fraude
const PERMISSION_EXCHANGE_RATE = 'exchange-rate'
const PERMISSION_MOVE_CREDIT = 'move_credit'
const PERMISSION_MENU = 'menu'
const PERMISSION_REPLY = 'reply'
const PERMISSION_UNAPPLY = 'unapply'
// Nuevos permisos para Smartbook 
const PERMISSION_SMARTBOOK = 'smartbook';
const ITEM_PERMISSION_ENTITY = 'item';


export {
  PERMISSION_CREATE,
  PERMISSION_EDIT,
  PERMISSION_SHOW,
  PERMISSION_LIST,
  PERMISSION_DELETE,
  PERMISSION_GET,
  VIEW_LIQUIDATION_WHOLESALER,
  VIEW_LIQUIDATION_RETAIL,
  VIEW_LIQUIDATION_SUPPLIER,
  PERMISSION_ISSUANCE,
  PERMISSION_CHANGE,
  PERMISSION_REFOUND,
  PERMISSION_CANCEL,
  PERMISSION_GUARANTEE,
  PERMISSION_GENERATE,
  PERMISSION_VIEW,
  PERMISSION_ASSIGN,
  PERMISSION_MOVE,
  PERMISSION_DELETED,
  PERMISSION_EDITED,
  PERMISSION_LIST_SHOW,
  PERMISION_VIEW_CANCEL_SUPPLIER,
  PERMISSION_AMEND,
  PERMISSION_EXPORT,
  PERMISSION_IMPORT,
  PERMISSION_IS_BILLABLE,
  PERMISSION_AUTO_BILL,
  PERMISSION_FORCED_CANCELLATION,
  PERMISSION_RECEIPT,
  PERMISSION_RETRIVE,
  PERMISSION_CAPTURE,
  PERMISSION_PAYMENT,
  PERMISSION_VOID,
  PERMISSION_EDIT_DUE_DATE,
  PERMISSION_PRICING,
  PERMISSION_FRAUD,
  PERMISSION_EXCHANGE_RATE,
  PERMISSION_MOVE_CREDIT,
  PERMISSION_MENU,
  PERMISSION_REPLY,
  PERMISSION_UNAPPLY,
  PERMISSION_SMARTBOOK,
  ITEM_PERMISSION_ENTITY,
}
